import type { HandlersPresenceHeroBlock } from '~/api/models/HandlersPresenceHeroBlock';

import type { CtaLink, PresenceHeroContent } from '~/marketing/presenceContract';

function ctaFromApi(c?: { label?: string; href?: string } | null): CtaLink | undefined {
  if (!c) return undefined;
  const label = c.label?.trim() ?? '';
  const href = c.href?.trim() ?? '';
  if (!label && !href) return undefined;
  return { label: label || 'Learn more', href: href || '#' };
}

/**
 * Maps OpenAPI `HandlersPresenceHeroBlock` (subset of fields) onto our richer `PresenceHeroContent`
 * by overlaying on static variant defaults for card copy, labels, etc.
 */
export function heroBlockToPartial(
  block: HandlersPresenceHeroBlock | undefined
): Partial<PresenceHeroContent> {
  if (!block) return {};
  return {
    eyebrow: block.eyebrow,
    headline: block.headline,
    subhead: block.subhead,
    trustLine: block.trustLine,
    prompt: block.prompt,
    responses: block.responses,
    primaryCta: ctaFromApi(block.primaryCta),
    secondaryCta: ctaFromApi(block.secondaryCta),
  };
}
